/**
 * Created by hyr on 19/1/30.
 * 活动各种名称配置文件, 需要用户手动配置
 */
export default {
  name: 'activity_2019_push', // 埋点名称
  aosName: 'push_news', // aos链接名称
  activity: 'push', // aos通用模块活动名称
};
